import { forwardRef, useId } from 'react';
import { controlClassName } from 'components/list/styles';

const NativeSelect = forwardRef(function NativeSelect(
  { label, id, className = '', ...props },
  ref
) {
  const generatedId = useId();
  const controlId = id || generatedId;
  const select = (
    <select {...props} ref={ref} id={controlId} className={`${controlClassName} ${className}`} />
  );
  if (!label) return select;
  return (
    <div className='min-w-0 space-y-2'>
      <label htmlFor={controlId} className='block text-sm font-medium text-gray-700'>
        {label}
      </label>
      {select}
    </div>
  );
});

export default NativeSelect;
